import { Link, useParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";

import styled from "styled-components";
import { motion } from "framer-motion";

import { getProduct } from "../../services/productRequestServices";

import Modal from "../../ui-kits/Modal";
import Slider from "../../ui-kits/Slider";

import ConsultingRequestModal from "../../components/general/modals/ConsultingRequestModal";
import HtmlContent from "../../components/general/misc/HtmlContent";
import LaptopSlider from "../../components/general/sliders/LaptopSlider";
import WhatsAppButton from "../../components/general/misc/WhatsAppButton";

import settingSvg from "../../assets/media/icons/setting.svg";
import starSvg from "../../assets/media/icons/star.svg";
import Close from "../../assets/media/icons/close";
import variables from "../../assets/js/variables";
const { colors } = variables;

const Product = () => {
  const { id } = useParams();
  const [isShowMore, toggleShowMore] = useState(false);
  const [isShowRequest, toggleShowRequest] = useState(false);
  const [productData, changeProductData] = useState(null);

  const getProductData = useCallback(() => {
    return getProduct(id).then((res) => changeProductData(res));
  }, [id]);

  useEffect(() => {
    getProductData();
  }, [getProductData]);

  return productData ? (
    <motion.div
      animate={{ opacity: 1 }}
      initial={{ opacity: 0 }}
      exit={{ opacity: 0 }}
    >
      <StyledProduct>
        <FloatingButton>
          <WhatsAppButton />
        </FloatingButton>

        <motion.div
          animate={{ transform: "translateY(0vh)", opacity: 1 }}
          initial={{ transform: "translateY(100vh)", opacity: 0 }}
          exit={{ transform: "translateY(100vh)", opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
        >
          <Styles className="row subpage__container">
            <div className="content-style content-one col-12 col-md-4 border border-blue rounded my-2 my-md-0 px-2 py-4 d-flex flex-column justify-content-between">
              <div className="content-one-over-flow px-3">
                <h1 className="Product_main__title text-green text-24">
                  {productData.title}
                </h1>
                <h2 className="Product_sub__title text-white text-18 my-3">
                  {productData.slogan}
                </h2>
                <p className="text-white text-14 text-justify">
                  {productData.slogan_description}
                </p>
              </div>
              <div>
                <DividerStyled className="border-blue" />
                <div className="d-inline-block text-green text-14">
                  تولید کننده
                </div>
                <div className="d-inline-block text-white text-14 mx-2">
                  {productData.builder}
                </div>
                {productData.customers && (
                  <>
                    <DividerStyled className="border-blue" />
                    <div className="text-green text-14">
                      مشتریان و صنایع نمونه
                    </div>
                    <div className="py-3">
                      {productData.customers.length > 3 ? (
                        <StyledCustomerSlider
                          className="StyledCustomerSlider"
                          settings={{
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            autoplay: true,
                            infinite: true,
                          }}
                        >
                          {productData.customers.map((customer) => (
                            <StylesCustomer key={customer.id + "1"}>
                              <Link
                                className="px-3 pb-2 d-flex align-items-center bg-white rounded overflow-hidden me-3 link-customer"
                                to={"/customers"}
                              >
                                <img
                                  src={customer.logo}
                                  alt=""
                                  className="w-100"
                                />
                              </Link>
                            </StylesCustomer>
                          ))}
                        </StyledCustomerSlider>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          {productData.customers.map((customer) => (
                            <div style={{ width: "100px" }}>
                              <StylesCustomer key={customer.id + "1"}>
                                <Link
                                  className="px-3 pb-2 d-flex align-items-center bg-white rounded "
                                  key={customer.id}
                                  to={"/customers"}
                                >
                                  <img
                                    src={customer.logo}
                                    alt=""
                                    className="w-100"
                                  />
                                </Link>
                              </StylesCustomer>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="content-style content-two col-12 col-md-4 border border-blue rounded my-2 my-md-0 px-3 py-4 d-flex flex-column justify-content-between">
              <div>
                <div className="text-green text-14 d-flex align-items-center mb-2">
                  <CircleLogo>
                    <img src={starSvg} alt="star" />
                  </CircleLogo>
                  <span className="pe-2">کاربردهای اصلی</span>
                </div>
                <HtmlContent rawHtml={productData.usages} />
                <button
                  className="btn border-blue text-green rounded text-14 px-3 py-2 mb-5"
                  onClick={() => toggleShowMore(true)}
                >
                  توضیحات بیشتر...
                </button>
              </div>
              <div>
                <div className="text-green text-14 d-flex align-items-center mb-2">
                  <CircleLogo>
                    <img src={settingSvg} alt="setting" />
                  </CircleLogo>
                  <span className="pe-2">امکانات اصلی</span>
                </div>
                <HtmlContent rawHtml={productData.options} />
              </div>
            </div>
            <div className="content-style content-three col-12 col-md-4 mt-2 mb-5 mt-md-0 d-flex flex-column justify-content-between">
              <LaptopSlider files={productData.photos.map((x) => x.url)} />
              <div>
                {productData.brochure && (
                  <a
                    className="btn border-blue text-white w-100 rounded text-14 "
                    href={productData.brochure}
                    download={productData.brochure}
                  >
                    دریافت بروشور محصول
                  </a>
                )}

                <div className="text-14 border border-blue my-2 p-2 rounded">
                  <div className="row justify-content-between">
                    <div className="col-auto text-green">هزینه لایسنس</div>
                    <div className="col-auto">{productData.license_price}</div>
                  </div>
                  <DividerStyled className="border-blue" />
                  <div className="row justify-content-between">
                    <div className="col-auto text-green">هزینه استقرار</div>
                    <div className="col-auto">
                      {productData.deployment_price}
                    </div>
                  </div>
                </div>
                <button
                  className="btn btn-blue w-100 rounded text-14 py-2"
                  onClick={() => toggleShowRequest(true)}
                >
                  درخواست دمو و مشاوره
                </button>
              </div>
            </div>
          </Styles>
        </motion.div>

        {isShowMore ? (
          <Modal>
            <StyledDialog>
              <div className="screen" onClick={() => toggleShowMore(false)} />
              <div className="dialog_container border-blue rounded bg-background text-white p-3">
                <div className="text-left">
                  <button
                    className="icon-close"
                    onClick={() => toggleShowMore(false)}
                  >
                    <Close />
                  </button>
                </div>
                <div className="px-2">
                  <div className="text-green text-14 my-2">
                    {productData.title}
                  </div>
                  <div className="dialog_container__content">
                    <HtmlContent rawHtml={productData.usages_description} />
                  </div>
                </div>
              </div>
            </StyledDialog>
          </Modal>
        ) : (
          <></>
        )}
        {isShowRequest && (
          <ConsultingRequestModal
            isOpen={isShowRequest}
            toggleOpen={toggleShowRequest}
            productInfo={{ title: productData.title }}
          />
        )}
      </StyledProduct>
    </motion.div>
  ) : null;
};

export default Product;

const Styles = styled.div`
  .content-style {
    max-height: 72vh !important;
    @media (max-width: 768px) {
      max-height: none !important;
    }
  }
  .content-two {
    overflow: scroll !important;
    @media (max-width: 768px) {
      max-height: none !important;
    }
  }

  .content-one-over-flow {
    overflow: scroll !important;
    max-height: 30vh !important;
    @media (max-width: 768px) {
      max-height: none !important;
      overflow: auto !important;
    }
  }
`;

const CircleLogo = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #00eeb8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const FloatingButton = styled.div`
  position: fixed;
  left: 20px;
  bottom: 20px;
  z-index: 2;
`;

const StyledDialog = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1003;
  .icon-close {
    position: absolute;
    left: 10px;
    top: 10px;
    border: none;
    outline: none;
    background: ${colors.background};
    border: 2px solid white;
    border-radius: 50%;
    padding: 8px;
    background: none;
    @media (max-width: 600px) {
      padding: 6px;
      left: 10px;
      top: 10px;
    }
    svg {
      width: 26px;
      height: 26px;
      @media (max-width: 600px) {
        width: 20px;
        height: 20px;
      }
      path {
        stroke: ${colors.text};
        fill: ${colors.text};
      }
    }
  }
  .screen {
    width: 100vw;
    height: 100vh;
    background: rebeccapurple;
    position: fixed;
    top: 0;
    background: rgba(0, 6, 50, 0.9);
  }

  .dialog_container {
    width: 600px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid;

    .text-left {
      text-align: left;
    }

    .dialog_container__content {
      max-height: 80vh;
      overflow: auto;
    }
  }

  @media (max-width: 768px) {
    .dialog_container {
      width: 90vw;
    }
  }
`;

const StyledProduct = styled.div`
  position: relative;
  color: white;
  text-align: right;
  line-height: 180%;
  overflow-y: auto;

  @media (max-width: 768px) {
    overflow-y: auto;
  }

  .Product_main__title {
    font-weight: 600;
  }

  .Product_sub__title {
    font-weight: 600;
    line-height: 31px;
  }

  .unordered-list {
    padding: 0;
    list-style: none;

    li::before {
      content: " + ";
      font-size: 18px;
      color: #00eeb8;
    }
  }
`;

const DividerStyled = styled.div`
  display: block;
  margin: 12px 0;
  ${({ direction }) =>
    direction === "vertical"
      ? "width: 0; height:100%; border-left: 1px solid;"
      : "width: 100%; height:0; border-top: 1px solid;"}
`;

const StyledCustomerSlider = styled(Slider)`
  display: flex;
  align-items: center;
  .slick-slide {
    min-width: 100px;
    max-width: 100px;
    margin: 0 5px;
  }
  .slick-list,
  .slick-track,
  .slick-slide {
    display: flex;
    align-items: center;
    width: 100%;

    > div {
      display: flex;
      align-items: center;
    }
  }
`;

const StylesCustomer = styled.span`
  min-width: 100%;
  max-width: 100%;
  a {
    width: 100px;
    height: 100px;
    float: left;
  }
`;
